module.exports = __webpack_public_path__ + "img/close-icon.aee4f0fd.svg";